import { applicationContext } from "core/utils";
import { BaseEditViewStore } from "core/stores";
import { FacilityInventoryCountHeaderService } from "application/facility-inventory/services";
import { FacilityInventoryCountFileUploadForm } from "application/facility-inventory/forms";
import { action } from "mobx";

@applicationContext
class FacilityInventoryCountFileUploadViewStore extends BaseEditViewStore {    
    constructor(rootStore) {
        const facilityInventoryCountHeaderService = new FacilityInventoryCountHeaderService(rootStore.application.baasic.apiClient);

        const facilityInventoryCountHeaderId = rootStore.routerStore.router.routerState.params.facilityInventoryCountHeaderId;

        super(rootStore, {
            name: "facility-inventory-count-file-upload",
            Form: FacilityInventoryCountFileUploadForm,
            actions: () => {
                return {
                    uploadFile: async () => {
                        const file = this.form.fields.get("file").files[0];
                        try{
                            await facilityInventoryCountHeaderService.uploadFile(facilityInventoryCountHeaderId, { file });
                        }
                        catch(err){
                            if(err && err.data && err.data.errors && err.data.errors[0]){
                                err.data.errors.forEach((message) => {
                                    this.rootStore.notificationStore.error(message);
                                });
                            }
                        }
                    } 
                };
            },
            FormClass: FacilityInventoryCountFileUploadForm
        });

        this.facilityInventoryCountHeaderId = facilityInventoryCountHeaderId;
        this.setTitle();
    }

    @action.bound
    async setTitle() {
		this.rootStore.viewStore.setNavigationOptions({
			hideColon: true
		});
	}

    @action.bound
    async createResource(resource) {
        if (!this.actions.uploadFile)
            return;
            
        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore)
                this.translationStore.applyMetadata(resource);

            await this.actions.uploadFile(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success("FACILITY_INVENTORY.FILE_UPLOAD.SUCCESS"));

        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error( "FACILITY_INVENTORY.FILE_UPLOAD.ERROR");
        }
    }
}

export default FacilityInventoryCountFileUploadViewStore;